import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Checkbox } from '../../components/common/Checkbox/Checkbox';
import Spinner from '../../components/common/Spinner';

import { DASHBOARD } from '../../routes/routes';
import { H4, P2 } from '../../styles/FontStyles';
import { Button, TermsWrapper } from '../../styles/GlobalComponents';
import { useWindowWide } from '../../helpers/wideScreen';

import { AnimatedDashboard } from '../../components';

import { getContentBlock } from '../../slices/content-block-slice';
import { Agreement } from '../Kyc/KycStyled';
import { getUserFromLS } from '../../helpers/localstorage-helper';
import axios from 'axios';

const TermsConditionsMigratedCheck = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation('kyc');

  const dispatch = useAppDispatch();
  const { contentBlock, loading } = useAppSelector(
    (state) => state.contentBlock
  );

  const kycLoading = useAppSelector((state) => state.kyc.loading);

  const [checkbox, setCheckbox] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [checkbox3, setCheckbox3] = useState(false);

  const confirmTerms = async () => {
    try {
      await axios.put(`/user/set-mavie-migration-modal-checked`);

      history.push(DASHBOARD);
    } catch (error: any) {
      console.log(error.response);
    }
  };

  useEffect(() => {
    dispatch(getContentBlock({ contentBlockId: 250, languageId: 1 }));
  }, [dispatch]);

  const wide = useWindowWide(1000);
  const wide2 = useWindowWide(1800);

  return (
    <AnimatedDashboard key={'kyc-agreement'}>
      <div
        style={{
          paddingBottom: !wide ? '150px' : '0',
          maxHeight: '90vh',
          overflow: 'scroll'
        }}
        className='noScrollBar'>
        {(loading || kycLoading) && <Spinner fullScreen={true} transparent />}

        <H4 center mb='40'>
          TERMS AND CONDITIONS
        </H4>
        <P2 center mb='40'>
          Welcome to Travelution. Your account has been successfully migrated to
          the new platform. Please review and accept the updated Terms and
          Conditions to proceed.
        </P2>
        <TermsWrapper height='calc(100vh - 600px)'>
          <div
            dangerouslySetInnerHTML={{
              __html: contentBlock && contentBlock.content
            }}
          />
        </TermsWrapper>

        <div style={{ maxWidth: wide2 ? 1000 : 700 }}>
          <Agreement>
            <Checkbox
              margin={'0 20px 0 0'}
              checked={checkbox}
              onClick={() => setCheckbox(!checkbox)}
            />
            <P2>
              {' '}
              I acknowledge my account was migrated and accept the updated Terms
              and Conditions.
            </P2>
          </Agreement>
          <Agreement>
            <Checkbox
              margin={'0 20px 0 0'}
              checked={checkbox2}
              onClick={() => setCheckbox2(!checkbox2)}
            />

            <P2>
              I understand my rank progress as of July 30 includes legacy volume
              from MaVie.
            </P2>
          </Agreement>
          <Agreement>
            <Checkbox
              margin={'0 20px 0 0'}
              checked={checkbox3}
              onClick={() => setCheckbox3(!checkbox3)}
            />

            <P2>
              I accept that rewards will be split: the legacy portion paid in
              welcome vouchers, and the rest in cash, following the 70/30 payout
              rule.
            </P2>
          </Agreement>
        </div>
        <Button
          maxWidth={wide && '200px'}
          disabled={!checkbox || !checkbox2 || !checkbox3}
          onClick={() => confirmTerms()}>
          {t('agreement.agree')}
        </Button>
      </div>
    </AnimatedDashboard>
  );
};

export default TermsConditionsMigratedCheck;
